import type { PaginatedMessagingAccount } from '@arhs-fleetback/types/entities/messaging-accounts';

import * as types from 'modules/messagingAccounts/actionTypes';
import type { FetchMessagingAccountsSuccessAction } from 'modules/messagingAccounts/types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';
import type { EntitySlice } from 'utils/ReduxUtils';

const messagingAccountAdapter = createEntityAdapter<PaginatedMessagingAccount>({ selectId: ({ id }) => id });

const updateManyFromPage = (
  state: EntitySlice<PaginatedMessagingAccount>,
  { payload }: FetchMessagingAccountsSuccessAction
) => messagingAccountAdapter.updateMany(state, payload.content);

export default createReducer(messagingAccountAdapter.getInitialState(), {
  [types.FETCH_MESSAGING_ACCOUNTS_SUCCESS]: updateManyFromPage,
  [types.DELETE_MESSAGING_ACCOUNT_SUCCESS]: messagingAccountAdapter.removeOne,
  [LOCATION_CHANGE]: messagingAccountAdapter.removeAll,
});
